export default "__VITE_ASSET__jwOEFHUK__"